import { modelRequest } from "@stem-sims/nexus"

export function recover({username="", emailAddress=""}){
    return modelRequest.post("/api/account/recover", {
        username: username,
        emailAddress: emailAddress
    })
}
